import Vue from 'vue'

export default {
	UPDATE_VERIFICATION_STATE (state, payload) {
		Vue.set(state, payload.field, payload.value)
	}
}
